var map = {
	"./Accenture-Logo.png": 2631,
	"./Amity_University_logo.png": 5450,
	"./DataScience.png": 9669,
	"./MS-Imagine-Academy-Main_Blue-v3.png": 8110,
	"./MTA.png": 1211,
	"./MachineLearning.png": 3650,
	"./Python.png": 8485,
	"./address.svg": 4309,
	"./address_image.svg": 8415,
	"./allstateindia-horizontal.png": 1725,
	"./analytics.png": 9443,
	"./animateTamo.png": 8619,
	"./animated_logo.svg": 4838,
	"./awign.png": 1541,
	"./aws.jpg": 3280,
	"./blogs_image.svg": 1108,
	"./choice.svg": 198,
	"./cloud_infrastructure.svg": 5820,
	"./coursera_logo.png": 8857,
	"./data_science.svg": 8712,
	"./developerActivity.svg": 9504,
	"./education.svg": 1803,
	"./eximius.jpg": 1238,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./firebase.png": 3616,
	"./fullstack.svg": 1272,
	"./gcp_logo.png": 4375,
	"./gcpskill.png": 3190,
	"./github_logo.png": 9214,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./ibm_logo.png": 5539,
	"./imagine.png": 8003,
	"./jsFramework.svg": 4406,
	"./logo-removebg-preview.png": 7799,
	"./manOnTable.svg": 969,
	"./microsoft.jpg": 3239,
	"./microsoft_logo.png": 3953,
	"./nationalit.png": 2058,
	"./niit.png": 6007,
	"./pcs.jpg": 6465,
	"./programmer.svg": 2075,
	"./projects_image.svg": 5739,
	"./socialmedia.svg": 1858,
	"./stack.png": 7443,
	"./studymatrix.png": 4159,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./tamojit.png": 3777,
	"./tamojit.svg": 7235,
	"./tamojit_das.png": 7812,
	"./tamojit_dastamojit_das.png": 6085,
	"./tamojitdas.svg": 5889,
	"./tamotrans.png": 1278,
	"./udacity.jpg": 3178,
	"./ui_ux_design.svg": 7880,
	"./ungineering.png": 8098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;